





















import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "@/components/main-header/main-header.vue";
import NavLeft from "@/components/nav-left/nav-left.vue";
import CommonPersonal from "../components/common-personal.vue";
@Component({
  components: {
    MainHeader,
    NavLeft,
    CommonPersonal,
  },
})
export default class Name extends Vue {}
